import React, {useCallback, useEffect, useState} from "react";
import {header} from "../../Components/Url/ApiUrl";
import {Logout} from "../../Components/Actions/Actions";
import swal from "sweetalert";
import ShowFile from "../../Components/ShowFile/ShowFile";
import ComplaintView from "./ComplaintView";
import {useTranslation} from "react-i18next";

const Complaints = () => {
    const {t} = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [showFile, setShowFile] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState(null)
    const status = {
        0:t('new'),
        1:t('read'),
        2:t('file_attached'),
        3:t('closed_by_farmer'),
        4:t('closed_by_admin')
    }
    const handleViewFile = async (filename) => {
        try {
            const response = await fetch(process.env.REACT_APP_API_ENDPOINT+'/files/dalolatnoma/'+filename, {
                method: "GET",
                headers: header
            });

            if (!response.ok) {
                alert(`${t('translation:cannot_upload_file')}. ${t('translation:token_expired')}`);
                window.location.reload();
                return;
            }

            const blob = await response.blob();

            // MIME tipini tekshirib, faqat PDF bo‘lsa ochamiz
            if (blob.type !== "application/pdf") {
                alert(t('pdf_only'));
                return;

            }
            const fileURL = URL.createObjectURL(blob);
            setPdfUrl(fileURL);
            setShowFile(true);
            // window.open(fileURL, "_blank");
        } catch (error) {
            alert(`${t('error')}: ` + error.message);
        }
    };
    const handleFetch = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/company/complaints`, {
                method: "GET",
                headers: header,
            });
            if (response.status === 401) {
                Logout();
                return;
            }
            if (!response.ok) {
                throw new Error(t('translation:no_data_found'));
            }
            const companyData = await response.json();
            setData(companyData);
        } catch (error) {
            console.error('Company fetch xatosi:', error);
            swal(t('error'), error.message || t('translation:unknown_error'), "error");
        } finally {
            setLoading(false);
        }
    }, [t]);

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);
    const toggleView = (d) => {
        setFormData(d);
        setShowModal(true);
    };
    const handleCancel = () => {
        setShowModal(false);
    }

    if (loading) {
        return <div className="loading-spinner">{t('loading')}</div>;
    }

    if (!data) {
        return <div>{t('translation:error_occured')}</div>;
    }
    return (
        <div className="fermer-complaint-index">

            <h3 className="py-3">{t('fermer_complaints')}</h3>
            <div id="w0" className="grid-view">
                <table className="table table-striped table-bordered">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>{t('farm_name')}</th>
                        <th>{t('viewed')}</th>
                        <th>{t('dalolatnoma')}</th>
                        <th>{t('status')}</th>
                        <th>{t('sended')}</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        data ?
                            data.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td>{item.farmer_name}</td>
                                        <td>{item.view}</td>
                                        <td>
                                            {item.file_name ? (
                                                <button className="btn btn-link p-0"
                                                        onClick={() => handleViewFile(item.file_name)}>
                                                    {t('dalolatnoma')} <i className="bi bi-file-pdf"></i>
                                                </button>
                                            ) : (
                                                <small><i>{t('no_file_found')}</i></small>
                                            )}
                                        </td>
                                        <td>{status[item.status]}</td>
                                        <td>{item.created_at}</td>
                                        <td>
                                            <button className="btn btn-transparent" onClick={()=>{toggleView(item)}}>
                                                <i className="bi bi-eye text-primary"></i>
                                            </button>
                                        </td>
                                    </tr>
                                )) : <tr>
                                <td colSpan="7">
                                    <div className="empty">{t('no_complaints')}</div>
                                </td>
                            </tr>
                    }

                    </tbody>
                </table>
            </div>
            {showFile && (
                <ShowFile
                    pdfUrl={pdfUrl}
                    setShowFile={setShowFile}
                />
            )}
            {
                showModal?
                    <ComplaintView
                        show={showModal}
                        handleClose={handleCancel}
                        data={formData}
                        handleViewFile={handleViewFile}
                        handleFetch={handleFetch}
                    />:null
            }
        </div>
    )
}
export default Complaints;